import { spacing } from '@chegg-ui/theme';
import styled from 'styled-components';
export var VenmoUsernameWrapper = styled.div.withConfig({
  componentId: "sc-1m6lyt3-0"
})(["display:flex;flex-direction:row;align-items:center;"]);
export var UserName = styled.div.withConfig({
  componentId: "sc-1m6lyt3-1"
})(["padding-left:", ";"], spacing.px12);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/VenmoView/styled.js
// module id = 4549
// module chunks = 11